export default
{
    components:
    {

    },

    props:
    {
        content: { type: Array, default: null }
    },

    data()
    {
        return {
            contentLeft: [],
            contentMiddle: [],
            contentRight: []
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$cols = this.$el.querySelectorAll('.js-col')

        const boss = []
        const collab = []

        for(let i = 0; i < this.content.length; i++)
        {
            if(this.content[i].boss)
            {
                boss.push(this.content[i])
            }

            if(this.content[i].collaborateur)
            {
                collab.push(this.content[i])
            }
        }



        for(let i = 0; i < this.content.length; i++)
        {
            if(this.content[i].boss)
            {
                this.content.splice(i, 1)
            }
        }

        for(let i = 0; i < this.content.length; i++)
        {
            if(this.content[i].collaborateur)
            {
                this.content.splice(i, 1)
            }
        }

        const thirdContentLength = this.content.length / 3
        const halfContentLength = this.content.length / 2

        for(let i = 0; i < this.content.length; i++)
        {
            if(!this.$root.isSmallScreen)
            {
                // dispatch content in three columns
                if(i <= thirdContentLength)
                {
                    this.contentLeft.push(this.content[i])
                }
                else if(i > thirdContentLength && i <= thirdContentLength * 2)
                {
                    this.contentMiddle.push(this.content[i])
                }
                else
                {
                    this.contentRight.push(this.content[i])
                }
            }
            else
            {
                // dispatch content in two columns
                if(i < halfContentLength)
                {
                    this.contentLeft.push(this.content[i])
                }
                else
                {
                    this.contentMiddle.push(this.content[i])
                }
            }
        }

        if(!this.$root.isSmallScreen)
        {
            for(let i = 0; i < boss.length; i++)
            {
                this.contentMiddle.unshift(boss[i])
            }

            for(let i = 0; i < collab.length; i++)
            {
                if(i%2===0)
                {
                    this.contentLeft.unshift(collab[i])
                }
                else
                {
                    this.contentRight.unshift(collab[i])
                }
            }
        }
        else
        {
            for(let i = 0; i < collab.length; i++)
            {
                if(i%2===0)
                {
                    this.contentMiddle.unshift(collab[i])
                }
                else
                {
                    this.contentLeft.unshift(collab[i])
                }
            }

            for(let i = 0; i < boss.length; i++)
            {
                this.contentLeft.unshift(boss[i])
            }
        }

        this.onResize()

        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onResize()
        {
            const colHeight0 = this.$cols[0].offsetHeight + ((this.$el.offsetHeight - this.$root.window.height) * .1)
            const colHeight1 = this.$cols[1].offsetHeight
            const colHeight2 = this.$cols[2].offsetHeight + ((this.$el.offsetHeight - this.$root.window.height) * 0.3)


            if(colHeight0 > colHeight1 && colHeight0 > colHeight2)
            {
                this.$el.style.paddingBottom = (((this.$root.window.height + this.$cols[0].offsetHeight * .1) - this.$root.window.height) + 150) + 'px'
            }
            else if(colHeight1 > colHeight0 && colHeight1 > colHeight2)
            {
                this.$el.style.paddingBottom = 150 + 'px'
            }
            else if(colHeight2 > colHeight0 && colHeight2 > colHeight1)
            {
                this.$el.style.paddingBottom = (((this.$root.window.height + this.$cols[2].offsetHeight * 0.2) - this.$root.window.height) + 50) + 'px'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-team/script.js